export default __webpack_public_path__ + "static/media/center2.be7144d4.jpg";